export const kPtOverlay2: Record<string, string> = {
  metro: 'Metro',
  vehicle_service_id: 'ID de serviço do veículo',
  vehicle: 'Veículo',
  ver__soft_: 'Ver. Soft.',
  ver__lists: 'Ver. Listas',
  ver__offer: 'Ver. Oferta',
  ver__param_: 'Ver. Parâm.',
  welcome: 'Bem-vindo',
  white_list_reload: 'Recarga da lista branca',
  yes: 'Sim',
  yesterday: 'Ontem',
  zone: 'Zona',
  zones: 'Zonas',
  unitWeek: 'Semana',
  unitWeeks: 'Semanas',
  page: 'Página',
  pages: 'Páginas',
  to_deploy: 'A implementar',
  do_not_deploy: 'Não implementar',
  overOn: 'Em',
  overOf: 'De',
  over: 'De',
  under: 'Abaixo',
  station_validators: 'Validadores de estação',
  onboard_validators: 'Validadores a bordo',
  any_terminal: 'Qualquer terminal',
  any_client: 'Qualquer cliente',
  lock: 'Bloqueio',
  locked: 'Bloqueado',
  unlocked: 'Desbloqueado',
  version: 'Versão',
  versions: 'Versões',
  description: 'Descrição',
  descriptions: 'Descrições',
  agent_card: 'Cartão do agente',
  agent_cards: 'Cartões do agente',
  card: 'Cartão',
  cards: 'Cartões',
  updated: 'Atualizado',
  cardUpdated: 'Atualizado',
  cardRegistered: 'Registado',
  ticket: 'Bilhete',
  tickets: 'Bilhetes',
  enabled: 'Ativado',
  disabled: 'Desativado',
  cardEnabled: 'Ativado',
  cardDisabled: 'Desativado',
  serial: 'Número de série',
  retries: 'Tentativas',
  registration: 'Registo',
  last_update: 'Última atualização',
  serial__base_16_: 'Número de série (base 16)',
  set_new_pin: 'Definir novo PIN',
  show: 'Mostrar',
  hide: 'Ocultar',
  retries__0_100_: 'Tentativas (0-100)',
  add_a_new_station: 'Adicionar uma nova estação',
  in_progress: 'Em curso',
  alertIn_progress: 'Em curso',
  other: 'Outro',
  parameters_version: 'Versão dos parâmetros',
  parameters_versions: 'Versões dos parâmetros',
  techRunning: 'Em execução',
  techStarted: 'Iniciado',
  techRunningStarted: 'Em execução (iniciado)',
  techError: 'Erro',
  techFailed: 'Falhou',
  techFailure: 'Falha',
  techRunningError: 'Em execução (erro)',
  techRunningFailed: 'Em execução (falhou)',
  techRunningFailure: 'Em execução (falha)',
  techWarning: 'Aviso',
  techRunningWarning: 'Em execução (aviso)',
  techCloseSent: 'Fecho enviado',
  techRunningCloseSent: 'Em execução (fecho enviado)',
  techErrorCloseSent: 'Erro, fecho enviado',
  techFailedCloseSent: 'Falhou, fecho enviado',
  techFailureCloseSent: 'Falha, fecho enviado',
  techRunningErrorCloseSent: 'Em execução (erro, fecho enviado)',
  techRunningFailedCloseSent: 'Em execução (falhou, fecho enviado)',
  techRunningFailureCloseSent: 'Em execução (falha, fecho enviado)',
  techWarningCloseSent: 'Aviso, fecho enviado',
  techRunningWarningCloseSent: 'Em execução (aviso, fecho enviado)',
  techClosedSuccessful: 'Fechado, com sucesso',
  techSuccessful: 'Com sucesso',
  techClosedError: 'Fechado, erro',
  techClosedFail: 'Fechado, falhou',
  techClosedFailure: 'Fechado, falha',
  techClosedCloseSent: 'Fechado, fecho enviado',
  techClosedErrorCloseSent: 'Fechado, erro, fecho enviado',
  techClosedFailCloseSent: 'Fechado, falhou, fecho enviado',
  techClosedFailureCloseSent: 'Fechado, falha, fecho enviado',
  techUncertain: 'Incerto',
  techUnconfirmed: 'Não confirmado',
  started: 'Iniciado',
  close_sent: 'Fecho enviado',
  error__close_sent: 'Erro, fecho enviado',
  fail_close_sent: 'Falhou, fecho enviado',
  failure_close_sent: 'Falha, fecho enviado',
  closed__successful: 'Fechado, com sucesso',
  closed__error: 'Fechado, erro',
  closed__fail: 'Fechado, falhou',
  closed__failure: 'Fechado, falha',
  closed__close_sent: 'Fechado, fecho enviado',
  closed__error__close_sent: 'Fechado, erro, fecho enviado',
  closed__fail__close_sent: 'Fechado, falhou, fecho enviado',
  closed__failure__close_sent: 'Fechado, falha, fecho enviado',
  error_portable_object: 'Erro, objeto portátil',
  fail_portable_object: 'Falhou, objeto portátil',
  failure_portable_object: 'Falha, objeto portátil',
  error_server: 'Erro, servidor',
  fail_server: 'Falhou, servidor',
  failure_server: 'Falha, servidor',
  incorrect_session_mac: 'MAC de sessão incorreto',
  incorrect_content: 'Conteúdo incorreto',
  error_terminal: 'Erro, terminal',
  fail_terminal: 'Falhou, terminal',
  failure_terminal: 'Falha, terminal',
  error_blacklisted_sam: 'Erro, SAM na lista negra',
  fail_blacklisted_sam: 'Falhou, SAM na lista negra',
  failure_blacklisted_sam: 'Falha, SAM na lista negra',
  unknown___resume_impossible: 'Desconhecido - Retoma impossível',
  start__s_: 'Início (s)',
  end__s_: 'Fim (s)',
  restart__s_: 'Reinício (s)',
  status_time__s_: 'Tempo de estado (s)',
  location_time__s_: 'Tempo de localização (s)',
  next_station_offset__s_: 'Desfasamento da próxima estação (s)',
  transaction: 'Transação',
  transactions: 'Transações',
  transactions_count: 'Contagem de transações',
  transactions_time__s_: 'Tempo de transações (s)',
  display_time__ms_: 'Tempo de exibição (ms)',
  to_deploy_by_default: 'A implementar por predefinição',
  number_of_seconds_from_midnight: 'Segundos desde a meia-noite',
  server_setting: 'Definição do servidor',
  server_settings: 'Definições do servidor',
  typeText: 'Texto',
  typeTexts: 'Textos',
  typeNumber: 'Número',
  typeNumbers: 'Números',
  add_setting: 'Adicionar definição',
  key: 'Chave',
  value: 'Valor',
  refresh: 'Atualizar',
  user_saved: 'Utilizador guardado',
  language: 'Idioma',
  search_by_account_or_email: 'Pesquisar por conta ou email',
  account: 'Conta',
  accounts: 'Contas',
  email: 'Email',
  role: 'Função',
  remove: 'Remover',
  phone: 'Telefone',
  set_new_password: 'Definir nova palavra-passe',
  password: 'Palavra-passe',
  administrator: 'Administrador',
  wshsm_administrator: 'Administrador WSHSM',
  rlhsm_administrator: 'Administrador RLHSM',
  gateway_administrator: 'Administrador Gateway',
  entry: 'Entrada',
  entries: 'Entradas',
  action: 'Ação',
  emails_only: 'Apenas emails',
  account_already_registered: 'Conta já registada',
  email_already_registered: 'Email já registado',
  login_success: 'Início de sessão com sucesso',
  server: 'Servidor',
  agent_card_created: 'Cartão do agente criado',
  agent_card_updated: 'Cartão do agente atualizado',
  equ_param_updated: 'Parâmetros do terminal atualizados',
  cli_param_updated: 'Parâmetros do cliente atualizados',
  station_created: 'Estação criada',
  station_updated: 'Estação atualizada',
  server_settings_updated: 'Definições do servidor atualizadas',
  server_setting_removed: 'Definição do servidor removida',
  user_created: 'Utilizador criado',
  user_updated: 'Utilizador atualizado',
  user_removed: 'Utilizador removido',
  terminal_updated: 'Terminal atualizado',
  client_updated: 'Cliente atualizado',
  client_registered: 'Cliente registado',
  put_in_stock: 'Colocar em stock',
  configuration: 'Configuração',
  hsm_group: 'Grupo HSM',
  hsm_groups: 'Grupos HSM',
  comment: 'Comentário',
  comments: 'Comentários',
  active_network: 'Rede ativa',
  active_networks: 'Redes ativas',
  activate: 'Ativar',
  deactivate: 'Desativar',
  all_networks: 'Todas as redes',
  authorization: 'Autorização',
  authorizations: 'Autorizações',
  last_connection: 'Última ligação',
  identifier: 'Identificador',
  ssl_common_name: 'Nome comum SSL',
  active: 'Ativo',
  inactive: 'Inativo',
  terminal_configuration_saved: 'Configuração do terminal guardada',
  client_configuration_saved: 'Configuração do cliente guardada',
  register: 'Registar',
  set_in_progress: 'Definir em curso',
  alertInProgress: 'Em curso',
  duration__ms_: 'Duração (ms)',
  transactionAborted_timeout: 'Abortada, tempo limite',
  transactionAborted_interruption: 'Abortada, interrupção',
  error_code: 'Código de erro',
  fail_code: 'Código de falha',
  failure_code: 'Código de falha',
  status_code: 'Código de estado',
  creation: 'Criação',
  update: 'Atualização',
  removal: 'Remoção',
  counter: 'Contador',
  occured: 'Ocorrido',
  count: 'Contagem',
  trend: 'Tendência',
  trends: 'Tendências',
  toUpdate: 'Atualizar',
  toRemove: 'Remover',
  last2days: 'Últimos 2 dias',
  the2daysbefore: 'Os 2 dias anteriores',
  last7days: 'Últimos 7 dias',
  the7daysbefore: 'Os 7 dias anteriores',
  last30days: 'Últimos 30 dias',
  the30daysbefore: 'Os 30 dias anteriores',
  other_errors: 'Outros erros',
  other_fails: 'Outras falhas',
  other_failures: 'Outras falhas',
  transactions_map: 'Mapa de transações',
  over30days: 'Ao longo de 30 dias',
  over365days: 'Ao longo de 365 dias',
  over7days: 'Ao longo de 7 dias',
  over2days: 'Ao longo de 2 dias',
  access: 'Acesso',
  mailing: 'Envio de emails',
  hsm_hi_level_r_label: 'Utilização dos canais: Crítico ([0-100]%)',
}
